import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../components/Loader/Loader';
import { P16 } from '../../components/Paragraph/Paragraph';
import RichTextReader from '../../components/RichTextReader/RichTextReader';
import { TitlePrincipal } from '../../components/Titles/Titles';
import UserPresentation from '../../components/UserPresentation/UserPresentation';
import { BASE_URL } from '../../constants';
import * as consejoSociedadCivilActions from './../../store/actions/consejoSociedadCivil';
import classes from './ConsejoSociedadCivil.module.scss';

const ConsejoSociedadCivil = props => {


    window.scroll({
        top: 0,
        behavior: 'smooth'
    })


    const consejeros = useSelector(state => state.sociedadCivil.consejeros);
    const presentacion = useSelector(state => state.sociedadCivil.presentacion);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(consejoSociedadCivilActions.fetch_consejo_sociedad_civil())
    }, [dispatch])

    return (
        <div className={classes.ConsejoSociedadCivil}>
            <TitlePrincipal>
                Consejo Sociedad Civil
            </TitlePrincipal>
            {presentacion ? <RichTextReader bodyText={presentacion} /> : <Loader />}

            <section className={classes.Consejeros}>
                {
                    consejeros ?
                        consejeros.map(c => <UserPresentation
                            cargo={c.Cargo}
                            nombre={c.Nombre}
                            imagen={BASE_URL + c.imagen.url}
                        />) : null
                }
            </section>
        </div>
    )
};

export default ConsejoSociedadCivil;